var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",attrs:{"action":_vm.action,"method":"GET"}},[_vm._t("default",null,null,{ update: _vm.update, updateOnMq: _vm.updateOnMq, formData: _vm.formData, reset: _vm.reset })],2)}
var staticRenderFns = []

export { render, staticRenderFns }